module.exports = {"230719001":"双子河街道","230719002":"铁林街道","230719003":"友好街道","230719100":"上甘岭镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230719.json
// module id = 847
// module chunks = 0